/**
 * Vuex modules
 * @link https://vuex.vuejs.org/guide/modules.html
 */
import * as authStore  from "./auth";
import * as crudStore   from "./crud";
import * as globalStore   from "./global";
import * as configStore from "./config";
export default { authStore, globalStore, crudStore, configStore};
